import * as React from 'react'
import { SVGProps } from 'react'
const SvgReturnBox = (props: SVGProps<SVGSVGElement>) => (
  <svg width={11} height={11} viewBox="0 0 11 11" fill="none" {...props}>
    <path
      d="M10.723 10.722H0V0h10.722v10.722h.001ZM.753 9.97H9.97V.753H.754v9.216Z"
      fill="#4E4E4E"
    />
    <path
      d="M6.554.753v3.783L5.234 3.42 3.913 4.536V.753h2.641ZM3.528 8.828H1.227v.753h2.3v-.753ZM2.86 7.607H1.227v.753H2.86v-.753ZM9.496 8.026h-1.47v1.47h1.47v-1.47Z"
      fill="#4E4E4E"
    />
  </svg>
)
export default SvgReturnBox
